import type { BlockDirectionType } from './types';

/** 等间距块相对当前图层的四个方向。 */
export const BlockDirectionMap = {
    left: 'left',
    right: 'right',
    up: 'up',
    down: 'down',
} as const satisfies Record<BlockDirectionType, BlockDirectionType>;

/** move 吸附阈值，单位为屏幕 CSS 像素。 */
export const MOVING_ABSORB_DISTANCE = 2;
/** resize 吸附阈值，单位为屏幕 CSS 像素。 */
export const RESIZING_ABSORB_DISTANCE = 2;
/** Scale 吸附阈值，单位为屏幕 CSS 像素；实现保留但功能仍关闭。 */
export const SCALE_ABSORB_DISTANCE = 2;
